import React, { useEffect, useState, useRef } from 'react';
import M from 'materialize-css/dist/js/materialize';
import { Button } from './ComponentsUI';
import { translate } from '../../utils/util';
import { validateInputsRequired } from '../../utils/handleChangeHooks';

const ConfirmModalUI = (props) => {
    let instaceMT = null;
    const modal = useRef();
    const [instanceM, setinstanceM] = useState();

    useEffect(() => {
        loadInstance(M.Modal.init(modal.current, {
            dismissible: true,
            onCloseEnd: () => close(),
        }));

        return () => {
            if (instaceMT && instaceMT.el) {
                M.Modal.init(instaceMT.el).destroy()
                M.Modal.init(instaceMT.el).close()
                instaceMT.el.M_Modal.destroy()
                instaceMT.close()
            }
        }
        // eslint-disable-next-line
    }, [modal]);

    useEffect(() => {
        if (props.open) {
            show();
        }
        // eslint-disable-next-line
    }, [props.open]);

    const loadInstance = (instance) => {
        setinstanceM(instance);
        instaceMT = instance;
    }

    const onConfirm = () => {
        if (props.validationInput && !validateInputsRequired(props.id)) {
            return;
        }
        if (props.onConfirm) {
            props.onConfirm();
        }
        close();

    }

    const onCancel = () => {
        if (props.onCancel) {
            props.onCancel();
        }
        close();
    };

    const close = () => {
        if (props.onClose) {
            props.onClose();
        }

        if (instanceM) {
            instanceM.close();
        }
    }

    const show = () => {
        if (instanceM) {
            instanceM.open();
        }
    }

    return (
        <div id={props.id ? props.id : 'confirm-modal'} ref={modal} className="modal" style={{ backgroundColor: '#ffffff' }}>
            <div className="modal-content black-text">
                <h4>{props.data.title}</h4>
                {props.data.message}
                {props.data.children}
            </div>
            <div className="modal-footer" style={{ backgroundColor: '#ffffff' }}>

                {props.showCancel &&

                    <div className="row" style={{ paddingLeft: '10px', paddingRight: '10px' }} >
                        <Button
                            className="col s12 m6 push-m6 btn btn-flat waves-effect waves-light"
                            type="button"
                            onClick={onCancel}
                            disabled={props?.disabledCancel}
                            secundary="true"
                            text={props.btnCancel ? props.btnCancel : translate('general:cancel')} />
                        <Button

                            type="button"
                            onClick={onConfirm}
                            text={props.btnConfirm ? props.btnConfirm : translate('general:confirm')} />
                    </div>
                }
                {!props.showCancel &&
                    <div className="row" style={{ marginLeft: '30%' }} >
                        <Button

                            type="button"
                            onClick={onConfirm}
                            text={props.btnConfirm ? props.btnConfirm : translate('general:confirm')} />
                    </div>
                }

            </div>
        </div >
    );
};

export default ConfirmModalUI;